import { Icon } from '@advanza/advanza_generic'
import { Col, Row } from '@advanza/grid'
import type { AddAggregatedReviewOptions } from 'actions/aggregatedReviews'
import AggregatedReviewsFilterContainer from 'containers/AggregatedReviewsFilterContainer'
import React from 'react'

interface AggregatedReviewsFilterFilter {
    page?: number
    searchKey?: string
    didInvalidate?: boolean
    [key: string]: unknown
}

export interface AggregatedReviewsFilterProps {
    filterId: string
    filter?: AggregatedReviewsFilterFilter
    count?: number
    isFetching?: boolean
    compact?: boolean
    defaultOptions?: Record<string, unknown>
    newEntityOptions?: Record<string, unknown>
    changeFilter: (id: string, options: Record<string, unknown>) => void
    add: (options: AddAggregatedReviewOptions) => void
}

class AggregatedReviewsFilter extends React.Component<AggregatedReviewsFilterProps> {
    _changeFilter = (options: Record<string, unknown>): void => {
        const { changeFilter, filterId } = this.props
        changeFilter(filterId, options)
    }

    componentDidMount(): void {
        const { defaultOptions = {}, filter } = this.props
        if (!filter) {
            this._changeFilter(defaultOptions)
        }
    }

    componentDidUpdate(prevProps: AggregatedReviewsFilterProps): void {
        const prevFilter = prevProps.filter ?? {}
        const { filter = {} } = this.props
        const didInvalidate = !prevFilter.didInvalidate && filter.didInvalidate
        if (didInvalidate) {
            this._changeFilter({})
        }
    }

    addEntity = (): void => {
        const { newEntityOptions, filterId, add } = this.props
        add({ ...newEntityOptions, filterId } as AddAggregatedReviewOptions)
    }

    render(): React.ReactNode {
        const { filter, compact } = this.props
        if (!filter || compact) {
            return null
        }

        return (
            <Row>
                <Col x>
                    <button type="button" className="plain" onClick={this.addEntity}>
                        <span className="inline-flex items-center gap-1 pt-2">
                            <Icon>add</Icon> Add
                        </span>
                    </button>
                </Col>
            </Row>
        )
    }
}

export default AggregatedReviewsFilterContainer(AggregatedReviewsFilter)
